<div *ngIf="error" class="alert alert-danger">
  <p>{{ error }}</p>
  <p class="m-0" i18n="@@support.inCaseYouAreFacingIssues">
    If you are facing issues in submitting the contact form, please contact us
    through <a href="mailto:help@bitoasis.net">help&#64;bitoasis.net</a>
  </p>
</div>

<div
  *ngIf="success"
  data-testid="support-successMsg-txt"
  class="alert alert-success"
>
  <ng-container i18n="@@support.success"
    >Your ticket has been sent successfully</ng-container
  >
</div>

<form class="form" class="white" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="" formGroupName="ticketData">
    <form-field
      class="front mb-0"
      label="Your Email *"
      i18n-label="@@support.email.label"
    >
      <input
        [disabled]="!isLoggedIn()"
        type="email"
        required
        formControlName="email"
        placeholder="Enter Your Email Address"
        i18n-placeholder="@@support.email.placeholder"
      />
    </form-field>
  </div>
  <small
    i18n="@@support.required"
    class="text-danger"
    *ngIf="email?.errors?.required && email?.touched"
    >* This field is required.</small
  >
  <small
    i18n="@@support.validEmailError"
    class="text-danger"
    *ngIf="email?.errors?.email && email?.touched"
  >
    Please enter a valid email address.
  </small>
  <div formGroupName="main" class="mt-3">
    <form-field
      class="front mb-0 pb-0"
      data-testid="support-categoryList-btn"
      label="Ticket Main Category *"
      i18n-label="@@support.mainCategory.label"
    >
      <ng-select
        [clearable]="false"
        [items]="categories"
        formControlName="category"
        bindLabel="label"
        required
        (change)="changeCategory()"
        placeholder="Select your main ticket type"
        i18n-placeholder="@@support.mainCategory.placeholder"
      ></ng-select>
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="category?.errors?.required && category?.touched"
      >* This field is required.</small
    >
    <form-field
      *ngIf="category.value"
      class="front mb-0 pb-0 pt-3"
      data-testid="support-subCategoryList-btn"
      label="Ticket Subcategory *"
      i18n-label="@@support.subCategory.label"
    >
      <ng-select
        [clearable]="false"
        [items]="category.value.subCategories"
        formControlName="subCategory"
        bindLabel="label"
        (change)="changeSubCategory()"
        required
        placeholder="Select your subticket type"
        i18n-placeholder="@@support.subCategory.placeholder"
      ></ng-select>
    </form-field>
    <small
      i18n="@@support.required"
      class="text-danger"
      *ngIf="
        category.value && subCategory?.errors?.required && subCategory?.touched
      "
      >* This field is required.</small
    >
  </div>
  <div *ngIf="subCategory.value" class="pt-3">
    <p [innerHTML]="subCategory.value.text"></p>
    <div class="hline"></div>

    <div formGroupName="ticketData">
      <otp-ticket
        [form]="form.get('ticketData')"
        [isVisible]="isOtpTicket(subCategory.value.key)"
        [category]="subCategory.value.key"
      ></otp-ticket>
      <document-ticket
        [isVisible]="isDocumentTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></document-ticket>
      <deposit-ticket
        [isVisible]="isDepositTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></deposit-ticket>
      <technical-issue-ticket
        [isVisible]="isTechnicalIssueTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      >
      </technical-issue-ticket>
      <name-ticket
        [isVisible]="isNameTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      >
      </name-ticket>
      <bank-ticket
        [isVisible]="isBankTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      >
      </bank-ticket>
      <phone-ticket
        [isVisible]="isPhoneTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></phone-ticket>
      <general-ticket
        [isVisible]="isGeneralTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></general-ticket>
      <residential-change-ticket
        [isVisible]="isResidentialChangeTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></residential-change-ticket>
      <email-change-ticket
        [isVisible]="isEmailChangeTicket(subCategory.value.key)"
        [form]="form.get('ticketData')"
        [category]="subCategory.value.key"
      ></email-change-ticket>
    </div>
  </div>

  <div class="submit mb-4 pt-4">
    <button
      data-testid="support-formSubmit-btn "
      class="btn btn-primary btn-block"
      [disabled]="loading || !category || loadingCaptcha"
    >
      <ng-container
        *ngIf="loading || loadingCaptcha; else notLoading"
        i18n="@@support.submitLoading"
      >
        Loading...
      </ng-container>

      <ng-template #notLoading>
        <ng-container
          *ngIf="isTypeCopperateOrVip; else regularSupport"
          i18n="@@support.submitEnquireButton"
        >
          Submit Your Enquiry
        </ng-container>

        <ng-template #regularSupport i18n="@@support.submitButton">
          Send Support Ticket
        </ng-template>
      </ng-template>
    </button>
  </div>
</form>
